import { Component, OnDestroy, OnInit } from '@angular/core';
import { Dealer } from '@app/core/models/dealer.model';
import { DataLayerService } from '@app/core/services/data-layer.service';
import { SessionService } from '@app/core/services/session.service';
import { StorageService } from '@app/core/services/storage.service';

@Component({
	selector: 'cng-consent',
	templateUrl: './consent.component.html',
	styleUrls: ['./consent.component.less'],
})
export class ConfigureConsentComponent {
	showBanner: boolean;
	adConsentGranted: boolean;
	adUserDataConsentGranted: boolean;
	adPersonalizationConsentGranted: boolean;
	analyticsConsentGranted: boolean;
	functionalityConsentGranted: boolean;
	personalizationConsentGranted: boolean;
	securityConsentGranted: boolean;

	dealer: Dealer = this.session_service.getDealer();
	website_url: string = this.dealer.website_url || null;

	constructor(
		private data_layer_service: DataLayerService,
		private storage_service: StorageService,
		private session_service: SessionService,
	) {
		this.showBanner = this.storage_service.getCookie('consentAcceptedRejected') === null;
	}

	acceptConsent() {
		this.showBanner = false;

		this.storage_service.setCookie('consentAcceptedRejected', 'true', 365);

		this.adConsentGranted = true;
		this.adUserDataConsentGranted = true;
		this.adPersonalizationConsentGranted = true;
		this.analyticsConsentGranted = true;
		this.functionalityConsentGranted = true;
		this.personalizationConsentGranted = true;
		this.securityConsentGranted = true;

		localStorage.setItem(
			'click_gtm_default_consents',
			JSON.stringify({
			  ad_storage: this.adConsentGranted ? 'granted' : 'denied',
			  ad_user_data: this.adUserDataConsentGranted ? 'granted' : 'denied',
			  ad_personalization: this.adPersonalizationConsentGranted ? 'granted' : 'denied',
			  analytics_storage: this.analyticsConsentGranted ? 'granted' : 'denied',
			  functionality_storage: this.functionalityConsentGranted ? 'granted' : 'denied',
			  personalization_storage: this.personalizationConsentGranted ? 'granted' : 'denied',
			  security_storage: this.securityConsentGranted ? 'granted' : 'denied',
			}),
		);

		this.pushConsent();
	}

	pushConsent() {
		const defaultConsent = localStorage.getItem("click_gtm_default_consents");
		const settings = JSON.parse(defaultConsent) || {};

		this.data_layer_service.gtag('consent', 'update',
			{
				'ad_storage': settings['ad_storage'] || 'denied',
				'ad_user_data': settings['ad_user_data'] || 'denied',
				'ad_personalization': settings['ad_personalization'] || 'denied',
				'analytics_storage': settings['analytics_storage'] || 'denied',
				'functionality_storage': settings['functionality_storage'] || 'denied',
				'personalization_storage': settings['personalization_storage'] || 'denied',
				'security_storage': settings['security_storage'] || 'denied'
			}
		);
	}

	getCookieUrl() {
		return this.website_url ? `${this.website_url}/cookie-policy.php` : '/configure/cookie-policy';
	}
}
